import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Colors, Icon, TagLabel, TooltipWrapper, Typography, } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH, getMediaMinWidth } from '../../constants/responsive';
const MIN_WIDTH_1240 = getMediaMinWidth(1240);
export const visibleOnlyOnMobile = css({
    display: 'inherit',
    visibility: 'visible',
    [MEDIA_MIN_WIDTH.small]: { display: 'none', visibility: 'hidden' },
    [MIN_WIDTH_1240]: { display: 'none', visibility: 'hidden' },
});
export const visibleOnlyOnTablet = css({
    display: 'none',
    visibility: 'hidden',
    [MEDIA_MIN_WIDTH.small]: { display: 'inherit', visibility: 'visible' },
    [MIN_WIDTH_1240]: { display: 'none', visibility: 'hidden' },
});
export const visibleOnlyOnDesktop = css({
    display: 'none',
    visibility: 'hidden',
    [MIN_WIDTH_1240]: { display: 'inherit', visibility: 'visible' },
});
export const hiddenOnDesktop = css({
    display: 'inherit',
    visibility: 'visible',
    [MIN_WIDTH_1240]: { display: 'none', visibility: 'hidden' },
});
const styles = labelStyles('ComparisonTableGroup', {
    table: css({
        display: 'grid',
        marginLeft: '-20px',
        marginRight: '-20px',
        '&:not(:first-of-type)': {
            marginTop: '40px',
        },
        [MEDIA_MIN_WIDTH.small]: {
            marginLeft: '0',
            marginRight: '0',
        },
    }),
    tableHeader: ({ minWidth }) => css(Object.assign({ display: 'flex', alignItems: 'center', textAlign: 'left', minWidth: `${minWidth !== null && minWidth !== void 0 ? minWidth : 125}px`, wordBreak: 'break-word', hyphens: 'auto', paddingRight: '32px' }, Typography.paragraph3Bold)),
    tableHeaderPlan: css(Object.assign({ display: 'flex', alignItems: 'center', textAlign: 'center' }, Typography.paragraph3Bold)),
    tableHeaderDropdown: css(Object.assign({ display: 'none', alignItems: 'center', textAlign: 'left', visibility: 'hidden', [MEDIA_MIN_WIDTH.small]: { display: 'flex', visibility: 'visible' }, [MIN_WIDTH_1240]: { display: 'none', visibility: 'hidden' } }, Typography.paragraph3Bold)),
    dropdownContainer: css({
        flexGrow: 1,
        [MIN_WIDTH_1240]: {
            display: 'none',
        },
    }),
    tableRow: (type) => css(Object.assign(Object.assign({ display: 'grid', gridTemplateColumns: '3fr repeat(2, 2fr)', minHeight: '60px', fontWeight: '400', color: Colors.neutral800, boxShadow: '0px -1px 0px 0px #d7d5d2 inset', padding: '0 20px' }, (type === 'header' && { fontWeight: '700' })), { [MEDIA_MIN_WIDTH.small]: {
            gridTemplateColumns: '3fr repeat(2, 2fr)',
        }, [MIN_WIDTH_1240]: {
            gridTemplateColumns: '3fr repeat(5, 2fr)',
        } })),
    tableData: (backgroundColor) => [
        css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: Colors[backgroundColor],
        }),
        backgroundColor &&
            css({
                borderBottom: `1px solid ${Colors.neutral400}`,
            }),
    ],
    tableDataDesktop: css({
        display: 'none',
        visibility: 'hidden',
        [MIN_WIDTH_1240]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            visibility: 'visible',
        },
    }),
    tableRowFeatureName: ({ minWidth }) => css(Object.assign(Object.assign({ display: 'flex', alignItems: 'center', boxShadow: '-1px 0px 0px 0px #d7d5d2 inset', justifyContent: 'space-between', paddingRight: '32px', maxWidth: '390px', wordBreak: 'break-word', hyphens: 'auto', minWidth: `${minWidth || 125}px` }, Typography.paragraph3Bold), { [MEDIA_MIN_WIDTH.small]: {
            paddingRight: '48px',
        }, [MIN_WIDTH_1240]: {
            paddingRight: '32px',
        } })),
    tableFeatureTitle: css(Object.assign({ padding: '8px 8px 8px 0' }, Typography.paragraph3Semibold)),
    tooltipStyles: css({
        width: '200px',
    }),
    tagLabelWrapper: css({
        marginLeft: '5px',
    }),
});
function CellContent(props) {
    if (props.icon) {
        return _jsx(Icon, { name: props.icon, size: "25px", color: "gray" });
    }
    return _jsx("span", { children: props.text });
}
export function Group({ columnHeaders, isFirstGroup, leftColumnDropdown, leftColumnHeader, leftColumnIndex, leftColumnMinWidth, rightColumnDropdown, rightColumnHeader, rightColumnIndex, rows = [], title, }) {
    return (_jsxs("table", Object.assign({ css: styles.table }, { children: [_jsx("thead", { children: _jsxs("tr", Object.assign({ css: styles.tableRow('header') }, { children: [_jsx("th", Object.assign({ css: [styles.tableHeader({ minWidth: leftColumnMinWidth })] }, { children: title })), columnHeaders.map((header) => (_jsx("th", Object.assign({ css: [styles.tableHeaderPlan, visibleOnlyOnDesktop] }, { children: header }), header))), isFirstGroup ? (_jsxs(_Fragment, { children: [_jsx("th", Object.assign({ css: styles.tableHeaderDropdown }, { children: _jsx("div", Object.assign({ css: styles.dropdownContainer }, { children: leftColumnDropdown })) })), _jsx("th", Object.assign({ css: styles.tableHeaderDropdown }, { children: _jsx("div", Object.assign({ css: styles.dropdownContainer }, { children: rightColumnDropdown })) })), _jsx("th", Object.assign({ css: [styles.tableData, visibleOnlyOnMobile] }, { children: leftColumnHeader })), _jsx("th", Object.assign({ css: [styles.tableData, visibleOnlyOnMobile] }, { children: rightColumnHeader }))] })) : (_jsxs(_Fragment, { children: [_jsx("th", Object.assign({ css: [styles.tableHeaderPlan, hiddenOnDesktop] }, { children: leftColumnHeader })), _jsx("th", Object.assign({ css: [styles.tableHeaderPlan, hiddenOnDesktop] }, { children: rightColumnHeader }))] }))] })) }), _jsx("tbody", { children: rows.map((row, index) => {
                    var _a, _b, _c, _d, _e, _f;
                    return (_jsxs("tr", Object.assign({ css: styles.tableRow('standard') }, { children: [_jsxs("td", Object.assign({ css: styles.tableRowFeatureName({
                                    minWidth: leftColumnMinWidth,
                                }) }, { children: [_jsxs("span", Object.assign({ css: styles.tableFeatureTitle }, { children: [row.header, _jsx("span", Object.assign({ css: styles.tagLabelWrapper }, { children: row.tagLabelText && (_jsx(TagLabel, Object.assign({ color: row.tagLabelColor }, { children: row.tagLabelText }))) }))] })), row.tooltip && (_jsx(TooltipWrapper, Object.assign({ allowMultilineTooltip: true, content: row.tooltip ? (_jsx("div", Object.assign({ css: styles.tooltipStyles }, { children: row.tooltip }))) : undefined, position: "east", tooltipId: `${row.header}-${index}` }, { children: () => _jsx(Icon, { color: "neutral800", name: "alertInfo", size: 15 }) })))] })), columnHeaders.map((_, columnIndex) => {
                                var _a, _b, _c;
                                return (_jsx("td", Object.assign({ css: [
                                        styles.tableData((_b = (_a = row.cells) === null || _a === void 0 ? void 0 : _a[columnIndex]) === null || _b === void 0 ? void 0 : _b.backgroundColor),
                                        visibleOnlyOnDesktop,
                                    ] }, { children: _jsx(CellContent, Object.assign({}, (_c = row.cells) === null || _c === void 0 ? void 0 : _c[columnIndex])) }), columnIndex));
                            }), _jsx("td", Object.assign({ css: [
                                    styles.tableData((_b = (_a = row.cells) === null || _a === void 0 ? void 0 : _a[leftColumnIndex]) === null || _b === void 0 ? void 0 : _b.backgroundColor),
                                    hiddenOnDesktop,
                                ] }, { children: _jsx(CellContent, Object.assign({}, (_c = row.cells) === null || _c === void 0 ? void 0 : _c[leftColumnIndex])) })), _jsx("td", Object.assign({ css: [
                                    styles.tableData((_e = (_d = row.cells) === null || _d === void 0 ? void 0 : _d[rightColumnIndex]) === null || _e === void 0 ? void 0 : _e.backgroundColor),
                                    hiddenOnDesktop,
                                ] }, { children: _jsx(CellContent, Object.assign({}, (_f = row.cells) === null || _f === void 0 ? void 0 : _f[rightColumnIndex])) }))] }), row.header));
                }) })] })));
}
//# sourceMappingURL=Group.js.map